"use strict";
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import SignController from "./controller/sign";
import CertSelectModal from "./controller/certSelectModal";
import SignService from "./service/sign";

export default angular.module("investmentProject.sign", [])
    .controller("SignController", SignController)
    .controller("CertSelectModal", CertSelectModal)
    .factory("SignService", SignService)
    .name;
